import { render, staticRenderFns } from "./expire.vue?vue&type=template&id=32cf95a3&scoped=true&"
import script from "./expire.vue?vue&type=script&lang=js&"
export * from "./expire.vue?vue&type=script&lang=js&"
import style0 from "./expire.vue?vue&type=style&index=0&id=32cf95a3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf95a3",
  null
  
)

export default component.exports